<template>
  <div class="main">
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
    />
    <BlogHeader
      blogTitle=""
      blogSubTitle=""
      :callBack=false
      AssetHeader= "/img/webp/bg-home-full.webp"
      height= "150px"
    />
    <div id="navLeftRight" >
      <ul>
        <li>
          <router-link
            :to="{name: 'Toelichting', params: { funnel: getFunnel_toelichting.stories.slice()[step].content.funnel, step: getFunnel_toelichting.stories.slice()[step].content.step - 1 } }"
            class=""
          >
            START MIJN VERKOOP
          </router-link>
          <a 
            href="" 
            @click.prevent="goBack"
          >
            <font-awesome-icon
              :style="{ marginRight: '8px' }"
              icon="chevron-left"
            />{{getFunnel_toelichting.stories.slice()[step - 1].content.intro_header}} </a>
        </li>
        <li>
          <a 
            href="" 
            @click.prevent="goBack"
          >
            <font-awesome-icon
              :style="{ marginRight: '8px' }"
              icon="chevron-right"
            />{{getFunnel_toelichting.stories.slice()[step].content.intro_header}} </a>
        </li>
      </ul>
    </div>
    <div
      v-for="(Toelichting, r) in getFunnel_toelichting.stories.slice()"
      :key="r"
    >

      <div
        v-if="Toelichting.content.Funnel == funnel && Toelichting.content.step == step"
      >
        <div class="">
          <h2>
            <span v-html=Toelichting.content.intro_header />
          </h2>
          <p class="blok">
            <span v-html=Toelichting.content.intro_tekst />
          </p>
        </div>
        <div class="line" >
          <div class="blok">
            <h3 class="step__title">
              <span v-html=Toelichting.content.step_header />
            </h3>
            <p class="step__title">
              <span v-html=Toelichting.content.step_toelichting />
            </p>
          </div>
          <a class="text-center btn btn-orange l-mt-3" :href=Toelichting.content.partnerURL target="_blank" rel="sponsored nofollow"> {{ Toelichting.content.partnerLinktext }} </a>
          <a class="text-center btn btn-blue l-mt-3" :href=Toelichting.content.blogURL target="_blank" rel="sponsored nofollow"> {{ Toelichting.content.blogLinktext }} </a>
          <div class="imgBlok">
            <img 
              class="image-fit"
              :src= Toelichting.content.AssetHeader
            >
          </div>
        </div>
      </div>

    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/ComponentHeader";
import BlogHeader from "@/components/ComponentBlogHeader";
import Footer from "@/components/ComponentFooter";
import { mapGetters } from "vuex";

export default {
  name: "MoreInfo",
  components: {
    Header,
    BlogHeader,
    Footer
  },
  props: {
    funnel: {
      type: String,
      required: false,
      default: ""
    },
    step: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["getFunnel_toelichting"]),
    setNumber: function() {
      return this.step ? this.step.split(',').map(Number) : null
    }
  }

};
</script>

<style scoped>
#navLeftRight ul 
  li:first-child {
    float:left;
    margin-left: 2%;
  }
  li:last-child {
    float:right;
    margin-right: 2%;
  }

.line {
  display: flex;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  align-content: space-around;
  margin: 2%;
}

.blok {
  flex-basis: 60%;
  padding: 5%;
}

.imgBlok{
  flex-basis: 40%;
  padding: 0 5%;
}

h3 {
  font-style: oblique;
  font-weight: bold;
}

@keyframes mouse-move {

}
@media (min-width: 240px) and (max-width: 720px) {

.blok {
  flex-basis: 100%;
}

.imgBlok {
  display: none; 
}


}
</style>
